import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';
import './i18n';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    beforeSend(event, hint) {
      const error = hint?.originalException;
      const message =
        (error instanceof Error ? error.message : String(error ?? '')) ||
        event.exception?.values?.[0]?.value ||
        '';

      if (/ResizeObserver loop/i.test(message)) return null;

      if (
        (error instanceof DOMException && error.name === 'AbortError') ||
        /canceled|cancelled|aborted|abort/i.test(message)
      ) {
        return null;
      }

      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          Something went wrong. Please refresh.
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
